<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Calendar</h1>
      <h4 class="subtitle is-4">Upcoming Events</h4>
      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>

      <b-table v-else :data="entries.isEmpty ? [] : entries" :bordered="isBordered" :striped="isStriped" :narrowed="isNarrowed" :hoverable="isHoverable" :loading="loading" :focusable="isFocusable" :mobile-cards="hasMobileCards">
        <template slot-scope="props">
          <b-table-column field="name" label="Event">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="speaker" label="Speaker">
            {{ props.row.speaker }}
          </b-table-column>

          <b-table-column field="date" label="Date" centered>
            <span class="tag is-success">
              {{ props.row.date|dateTime }}
            </span>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large">
                </b-icon>
              </p>
              <p>No upcoming events. Check back later.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import CalendarAPI from '@/services/api/Calendar';
import { dateFormatter, } from '@/mixins/TimeFormat';

export default {
  name: 'CalendarPage',
  mixins: [dateFormatter,],
  data() {
    return {
      loading: true,
      entries: [],
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,
    };
  },
  mounted() {
    CalendarAPI.getFutureCalendarEntries()
      .then(entries => {
        this.entries = entries;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
</style>
